const canPayWithApplePay = () => Boolean(window?.ApplePaySession?.canMakePayments?.());

export default canPayWithApplePay;
